import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '../Card/Card';
import styles from './ObjectifPilote.module.css';

/**
 * ObjectifPilote — barre de progression shimmer + double engagements.
 *
 * Props :
 *  - title       : "Objectif pilote · 14 jours"
 *  - description : "Générer 7 avis Google en 14 jours — …"
 *  - current     : 4
 *  - goal        : 7
 *  - revyoCommitments : string[]   (sinon defaults i18n)
 *  - restoCommitments : string[]
 *
 * IDs préservés pour le backend :
 *  - #objectif-barre  (sur la barre de progression)
 *  - #objectif-chiffre (sur "9/15")
 */
export default function ObjectifPilote({
  title,
  description,
  current = 9,
  goal = 15,
  revyoCommitments,
  restoCommitments,
}) {
  const { t } = useTranslation('dashboard');

  const safeTitle = title || t('objectif_pilote.default_title');
  const safeDescription = description || t('objectif_pilote.default_description');
  const safeRevyo = revyoCommitments || [
    t('objectif_pilote.default_revyo_1'),
    t('objectif_pilote.default_revyo_2'),
  ];
  const safeResto = restoCommitments || [
    t('objectif_pilote.default_resto_1'),
    t('objectif_pilote.default_resto_2'),
  ];

  const pct = Math.max(0, Math.min(100, (current / goal) * 100));

  return (
    <Card span={6} rowSpan={2} id="bloc-objectif-pilote">
      <div className={styles.row}>
        <div>
          <h2 className={styles.title}>
            <span className={styles.icon}>🎯</span> {safeTitle}
          </h2>
          <div id="objectif-message" className={styles.sub}>{safeDescription}</div>
          <div className={styles.track}>
            <div
              id="objectif-barre"
              className={styles.fill}
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
        <div id="objectif-chiffre" className={styles.counter}>
          {current}/{goal}
        </div>
      </div>

      <div className={styles.engagements}>
        <div className={`${styles.engagement} ${styles.engGreen}`}>
          <div className={styles.engTitle}>{t('objectif_pilote.engagements_revyo_title')}</div>
          <ul>
            {safeRevyo.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </div>
        <div className={`${styles.engagement} ${styles.engOrange}`}>
          <div className={styles.engTitle}>{t('objectif_pilote.engagements_resto_title')}</div>
          <ul>
            {safeResto.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </div>
      </div>
    </Card>
  );
}
